<template>
    <div>
        <editView ref="historyEditView" :_dataId.sync="_dataId" :dealType="dealType" :parent-target="_self"
            :page-type="pageType" @reload="handleReload" @goBackIndex="handleGoBackIndex">
            <template slot="right-button">
                <div>
                    <el-button type="primary" plain v-if="replaceBarcode && formData.stat >= 64
                        && formData.stat != 96 && formData.stat != 97 && formData.stat != 98
                        && !isAppeal && dealType != 'orderEdit' && !isSite && !siteDeal" class="button-sty"
                        @click="showReplaceBarcodeDialogForHistory = true" icon="el-icon-tickets">更换条码
                    </el-button>


                    <el-button type="primary" plain v-if="!isSite && orderQuestion
                        && formData.stat >= 64 && formData.stat <= 96" class="button-sty" @click="getTYJShortUrl()"
                        icon="el-icon-tickets">问卷调查
                    </el-button>
                </div>
            </template>

        </editView>
        <replace-barcode-dialog-for-history v-if="showReplaceBarcodeDialogForHistory"
            @doReplaceBarcodeCheck="doReplaceBarcodeCheckForHistory" :visiable.sync="showReplaceBarcodeDialogForHistory"
            :param="orderRemarkParam" />
    </div>
</template>

<script>
import editView from "@/views/workorder/historicalData/historicalWorkOrder/editMain.vue";
import replaceBarcodeDialogForHistory from "@/views/dialogCommon/replaceBarcodeDialogForHistory.vue";
import { mapGetters } from "vuex";
export default {
    watch: {
        historical_workorder_form_data: function (val) {
            this.formData = val;
        }

    },
    components: {
        editView,
        replaceBarcodeDialogForHistory
    },
    computed: {
        ...mapGetters(["permissions"]),
        ...mapGetters("historicalWorkOrder", ["historical_workorder_form_data"]),
    },
    data() {
        return {
            // 按钮显隐
            showReplaceBarcodeDialogForHistory: false,
            orderParam: {},
            // 权限
            replaceBarcode: false,
            orderQuestion: false,
            // 表单数据(通过vuex的状态机制获取)
            formData: {},
            // 网点标识(通过vuex的状态机制获取)
            isSite: false,

        }
    },
    props: {
        _dataId: [String, Number],
        dealType: {
            type: Boolean,
            default: false
        },
        pageType: {},
        siteDeal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleReload() {
            this.$emit('reload');
        },
        handleGoBackIndex() {
            this.$emit('goBackIndex');
        },
        doReplaceBarcodeCheckForHistory(type) {
            this.showReplaceBarcodeDialogForHistory = false
            if (type == 1) {
                this.$refs["historyEditView"].getData();
            }
        },
    },
    created() {
        this.replaceBarcode = this.permissions["replaceBarcode"];
        this.orderQuestion = this.permissions["orderQuestion"];
    },
    mounted() {
        console.log("editView加载开始")
        this.isSite = this.$refs["editView"].isSite;
        console.log("editView加载开始")
    }
};
</script>

<style lang="scss"></style>
